
import squid from "squid";
squid(page.moduleConfig);
